import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App, { GolbalContext } from "./App";

import ProductProvider from "./contexts/ProductContext";
import SidebarProvider from "./contexts/SidebarContext";
import CartProvider from "./contexts/CartContext";
import DabinxProductProvider from "./contexts/DabinxProductContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SidebarProvider>
    <CartProvider>
      <ProductProvider>
      <DabinxProductProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </DabinxProductProvider>
      </ProductProvider>
    </CartProvider>
  </SidebarProvider>
);
